import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import { AuthContext } from "../../routes/AuthContext";
import { toast } from "react-toastify";
import "./Profile.css";

/* ✅ ENV BASE URL */
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Profile = () => {
  const { user, updateUser } = useContext(AuthContext);

  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    first_name: "",
    email: "",
    mobile_number: "",
  });

  /* 🔁 Sync form when user updates */
  useEffect(() => {
    if (user) {
      setFormData({
        first_name: user.first_name || "",
        email: user.email || "",
        mobile_number: user.mobile_number || "",
      });
    }
  }, [user]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  /* ================= UPDATE PROFILE ================= */
  const handleUpdate = async () => {
    try {
      setLoading(true);

      const fd = new FormData();
      fd.append("customer_id", user.customer_id);
      fd.append("first_name", formData.first_name);
      fd.append("email", formData.email);
      fd.append("mobile_number", formData.mobile_number);

      const res = await axios.post(`${BASE_URL}customer_details_update`, fd);


      // ✅ HTTP 200 = SUCCESS
      if (res.status === 200) {
        updateUser({
          first_name: formData.first_name,
          email: formData.email,
          mobile_number: formData.mobile_number,
        });

        toast.success("Profile updated successfully ✅");
        setEditMode(false);
      }
    } catch (err) {
      console.error(err);
      toast.error("Update failed ❌");
    } finally {
      setLoading(false);
    }
  };

  if (!user) return null;

  return (
    <div className="profile-container">
      <h1>Profile</h1>

      <div className="profile-info">
        <div className="info-row">
          <label>Name:</label>
          {editMode ? (
            <input
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
            />
          ) : (
            <span>{user.first_name}</span>
          )}
        </div>

        <div className="info-row">
          <label>Email:</label>
          {editMode ? (
            <input
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          ) : (
            <span>{user.email}</span>
          )}
        </div>

        <div className="info-row">
          <label>Mobile:</label>
          {editMode ? (
            <input
              name="mobile_number"
              value={formData.mobile_number}
              onChange={handleChange}
            />
          ) : (
            <span>{user.mobile_number}</span>
          )}
        </div>
      </div>

      <div className="profile-actions">
        {editMode ? (
          <>
            <button
              className="save-btn"
              onClick={handleUpdate}
              disabled={loading}
            >
              {loading ? "Saving..." : "Save"}
            </button>
            <button
              className="cancel-btn"
              onClick={() => setEditMode(false)}
              disabled={loading}
            >
              Cancel
            </button>
          </>
        ) : (
          <button
            className="edit-btn"
            onClick={() => setEditMode(true)}
          >
            Edit Profile
          </button>
        )}
      </div>
    </div>
  );
};

export default Profile;
